import { render, staticRenderFns } from "./StreamPlanSettings.vue?vue&type=template&id=4ae7473e"
import script from "./StreamPlanSettings.vue?vue&type=script&lang=js"
export * from "./StreamPlanSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports